import { Instance, Instances, useGLTF, useTexture } from '@react-three/drei';
import { useEffect, useMemo, useRef, useState } from 'react';
import * as THREE from 'three';

// Preload the pot model
useGLTF.preload('/env/pot.glb');

export function Pot({ jsonFile, texturePath }) {
    const { nodes } = useGLTF('/env/pot.glb', true, (error) => {
        console.error('Failed to load model', error)
    })

    // Preload the texture
    useTexture.preload(texturePath);

    // Load and configure the plant texture
    const potTexture = useTexture(texturePath)
    potTexture.colorSpace = THREE.SRGBColorSpace
    potTexture.flipY = false
    potTexture.channel = 1
    potTexture.generateMipmaps = false

    // Create a static MeshBasicMaterial
    const material = useMemo(
        () =>
            new THREE.MeshBasicMaterial({
                 toneMapped: false,side:THREE.DoubleSide, transparent:false, map:potTexture

            }),
        [texturePath]
    )

    // State to store instance data
    const [data, setData] = useState([])

    useEffect(() => {
        fetch(jsonFile)
            .then(response => response.json())
            .then(jsonData => {
                const parsedData = Object.values(jsonData).map((entry) => ({
                    position: mapAxes(entry.position || [0, 0, 0]),
                    scale: mapScale(entry.scale || [0, 0, 0]),
                    rotation: mapRotation(entry.rotation || [0, 0, 0]),
                }));
                setData(parsedData);
            })
            .catch(error => console.error('Error loading JSON:', error));
    }, [jsonFile])

    return (
        data.length > 0 && (
            <Instances
                range={data.length}
                geometry={nodes.mainPOT.geometry}
                material={material}
            >
                {data.map((props, i) => (
                    <Pots key={i} {...props} />
                ))}
            </Instances>
        )
    )
}

function Pots({ position, scale, rotation }) {
    const ref = useRef()
    return (
        <group
            position={position}
            scale={scale}
            rotation={rotation}
        >
            <Instance ref={ref} />
        </group>
    )
}

// Function to remap Blender axes to Three.js axes
function mapAxes([x, y, z]) {
    return [x, z, -y] 
  }
  
  function mapRotation([rx, ry, rz]) {
    return [rx, rz,-ry] 
  }
  function mapScale([rx, ry, rz]) {
    return [rx, ry, rz] 
  }